var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useState, useCallback, useLayoutEffect } from "react";
function getDimensionObject(node) {
  var rect = node.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: "x" in rect ? rect.x : rect.top,
    left: "y" in rect ? rect.y : rect.left,
    x: "x" in rect ? rect.x : rect.left,
    y: "y" in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom
  };
}
export function useDimensions(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.liveMeasure,
    liveMeasure = _c === void 0 ? true : _c;
  var _d = __read(useState({}), 2),
    dimensions = _d[0],
    setDimensions = _d[1];
  var _e = __read(useState(null), 2),
    node = _e[0],
    setNode = _e[1];
  var ref = useCallback(function (node) {
    setNode(node);
  }, []);
  useLayoutEffect(function () {
    if (node) {
      var measure_1 = function () {
        return window.requestAnimationFrame(function () {
          return setDimensions(getDimensionObject(node));
        });
      };
      measure_1();
      if (liveMeasure) {
        window.addEventListener("resize", measure_1);
        window.addEventListener("scroll", measure_1);
        return function () {
          window.removeEventListener("resize", measure_1);
          window.removeEventListener("scroll", measure_1);
        };
      }
    }
  }, [node]);
  return [ref, dimensions, node];
}
export default useDimensions;